import { filterWords } from '../data/curriculum/generators';
import type { Trin } from '../types';

export const TRIN_PROOF_DURATION_MS = 35_000;
export const TRIN_PROOF_MIN_ACCURACY = 0.95;

/** Short word list for trin-bevis (~8–12 ord). */
export function buildTrinProofText(trin: Trin, seed = 0): string {
  const keys = trin.unlockedKeys;
  const pool = buildWordPool(trin, keys);
  if (pool.length === 0) {
    return trin.unlockedKeys.filter((k) => k !== ' ').join(' ').repeat(3);
  }
  const shuffled = shuffle(pool, seed);
  const count = Math.min(12, Math.max(8, shuffled.length));
  return shuffled.slice(0, count).join(' ');
}

function buildWordPool(trin: Trin, keys: string[]): string[] {
  const fromRounds = new Set<string>();
  for (const r of trin.rounds) {
    const sample = r.generate({});
    for (const w of sample.split(/\s+/)) {
      const t = w.trim();
      if (t.length >= 2) fromRounds.add(t);
    }
  }
  const filtered = filterWords([...fromRounds], keys);
  if (filtered.length >= 6) return filtered;
  return filterWords(
    keys.filter((k) => k !== ' ').map((k) => k + k),
    keys,
  );
}

export function isTrinProofPassed(accuracy: number, completed: boolean): boolean {
  return completed && accuracy >= TRIN_PROOF_MIN_ACCURACY;
}

function shuffle<T>(arr: T[], seed: number): T[] {
  const out = [...arr];
  let s = seed || 1;
  for (let i = out.length - 1; i > 0; i--) {
    s = (s * 16807 + 0) % 2147483647;
    const j = s % (i + 1);
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out;
}
